import { __assign, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { font, color, spacing, border } from '@metro-ui/tokens/js';
import { fontStack } from '../utils/fontStack';
function fontSettings(size) {
    switch (size) {
        case 'small':
            return "\n        font-size: " + font.heading.h6.size + ";\n        line-height: " + font.heading.h6['line-height'] + ";\n        min-width: " + font.heading.h6['line-height'] + ";\n      ";
        case 'large':
            return "\n        font-size: " + font.text.medium.size + ";\n        line-height: " + font.text.medium['line-height'] + ";\n        min-width: " + font.text.medium['line-height'] + ";\n      ";
        default:
            return "\n        font-size: " + font.text.small.size + ";\n        line-height: " + font.text.small['line-height'] + ";\n        min-width: " + font.heading.h5['line-height'] + ";\n      ";
    }
}
var maxHeightMap = {
    small: '1rem',
    medium: '1.25rem',
    large: '1.5rem',
};
function maxHeight(size) {
    return size ? maxHeightMap[size] : maxHeightMap.medium;
}
export var Indicator = styled(function (_a) {
    var size = _a.size, className = _a.className, children = _a.children, htmlAttributes = __rest(_a, ["size", "className", "children"]);
    return (React.createElement("div", __assign({}, htmlAttributes, { className: className }), children));
})(function (_a) {
    var size = _a.size;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    ", ";\n    font-weight: ", ";\n    max-height: ", ";\n\n    padding: ", " ", ";\n\n    border-radius: ", ";\n\n    background-color: ", ";\n    color: ", ";\n\n    white-space: nowrap;\n\n    cursor: default;\n    user-select: none;\n    -webkit-user-drag: none;\n\n    ", "\n  "], ["\n    ", "\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    ", ";\n    font-weight: ", ";\n    max-height: ", ";\n\n    padding: ", " ", ";\n\n    border-radius: ", ";\n\n    background-color: ", ";\n    color: ", ";\n\n    white-space: nowrap;\n\n    cursor: default;\n    user-select: none;\n    -webkit-user-drag: none;\n\n    ", "\n  "])), fontStack, fontSettings(size), font.weight.heavy, maxHeight(size), spacing.none, spacing['xx-small'], border.radius.full, color.attention, color.brand.primary.default, size === 'large' && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      padding-left: ", ";\n      padding-right: ", ";\n    "], ["\n      padding-left: ", ";\n      padding-right: ", ";\n    "])), spacing['x-small'], spacing['x-small']));
});
Indicator.propTypes = {
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    className: PropTypes.string,
    children: PropTypes.node,
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=Indicator.js.map